import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../../store/slices/authSlice';
import Dialog from './Dialog';

const SessionExpiredDialog = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Auto-redirect after 3 seconds
  useEffect(() => {
    let timer;
    if (isOpen) {
      timer = setTimeout(() => {
        // First close the dialog
        onClose();
        // Then clear auth state
        dispatch(logout());
        // Finally redirect
        navigate('/login', { replace: true });
      }, 3000);
    }
    return () => clearTimeout(timer);
  }, [isOpen, dispatch, navigate, onClose]);

  const handleRelogin = () => {
    // First close the dialog
    onClose();
    // Then clear auth state
    dispatch(logout());
    // Finally redirect
    navigate('/login', { replace: true });
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Session Expired"
      showCloseButton={false}
      maxWidth="sm"
    >
      <div className="p-8">
        <div className="flex items-center justify-center mb-6">
          <div className="relative">
            <svg className="w-16 h-16 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div className="absolute -top-2 -right-2">
              <span className="flex h-4 w-4">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-4 w-4 bg-red-500"></span>
              </span>
            </div>
          </div>
        </div>
        <div className="text-center space-y-4">
          <h3 className="text-xl font-semibold text-gray-900">
            Session Expired
          </h3>
          <p className="text-gray-600">
            For your security, your session has expired due to inactivity.
          </p>
          <p className="text-gray-500 text-sm">
            You will be redirected to the login page in a few seconds...
          </p>
        </div>
        <div className="mt-8 flex justify-center">
          <button
            onClick={handleRelogin}
            className="w-full sm:w-auto px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transform transition-transform duration-150 hover:scale-105 flex items-center justify-center space-x-2"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
            </svg>
            <span>Log In Now</span>
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default SessionExpiredDialog;
